import React, { createContext, useContext, useState, useCallback, ReactNode } from 'react';

interface AiAgentContextType {
  isOpen: boolean;
  toggleOpen: () => void;
  /** Abre o chat já perguntando algo — usado por "Ver ajuste" e pelos alertas. */
  openWith: (prompt: string) => void;
  /** Pergunta pendente; o chat consome uma única vez ao terminar de carregar. */
  pendingPrompt: string | null;
  consumePrompt: () => void;
}

const AiAgentContext = createContext<AiAgentContextType>({
  isOpen: false,
  toggleOpen: () => {},
  openWith: () => {},
  pendingPrompt: null,
  consumePrompt: () => {},
});

interface AiAgentProviderProps {
  children: ReactNode;
}

export function AiAgentProvider({ children }: AiAgentProviderProps) {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [pendingPrompt, setPendingPrompt] = useState<string | null>(null);

  const toggleOpen = useCallback(() => setIsOpen((p) => !p), []);
  const openWith = useCallback((prompt: string) => {
    setPendingPrompt(prompt);
    setIsOpen(true);
  }, []);
  const consumePrompt = useCallback(() => setPendingPrompt(null), []);

  return (
    <AiAgentContext.Provider value={{ isOpen, toggleOpen, openWith, pendingPrompt, consumePrompt }}>
      {children}
    </AiAgentContext.Provider>
  );
}

export function useAiAgentToggle(): AiAgentContextType {
  return useContext(AiAgentContext);
}
